export default __webpack_public_path__ + "795189e04a6df5e11fabb2a0da68517d.webp";